<template>
  <ClientOnly>
    <Suspense
      v-if="shouldLoad"
    >
      <component
        :is="currentDrawerComponent"
        :is-open="isOpen"
        :active-state="activeState"
        :client-info="clientInfo"
        :style="cssVariables"
        @close="handleClose"
        @submit="handleSubmit"
        @state-change="handleStateChange"
        @language-selected="handleLanguageSelected"
        @chatbot-click="handleChatbotClick"
      />
      <template #fallback>
        <div class="drawer-loading">
          Loading component...
        </div>
      </template>
    </Suspense>
  </ClientOnly>
</template>

<script setup>
import { computed, defineAsyncComponent, toRef } from "vue";
import { useBreakpoints, breakpointsTailwind } from "@vueuse/core";
import { useChatTheme } from "../../composables";
const props = defineProps({
  isOpen: { type: Boolean, required: false, default: false },
  activeState: { type: String, required: false, default: "closed" },
  clientInfo: { type: Object, required: true },
  shouldLoad: { type: Boolean, required: false, default: false }
});
const emit = defineEmits(["close", "submit", "stateChange", "languageSelected", "chatbotClick"]);
const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller("md");
const { cssVariables } = useChatTheme(toRef(props, "clientInfo"));
const currentDrawerComponent = computed(() => {
  return isMobile.value ? defineAsyncComponent(() => import("./MobileDrawer.vue")) : defineAsyncComponent(() => import("./ChatDrawer.vue"));
});
function handleClose() {
  emit("close");
}
function handleSubmit(formData) {
  emit("submit", formData);
}
function handleStateChange(state) {
  emit("stateChange", state);
}
function handleLanguageSelected(_languageCode) {
  emit("languageSelected", _languageCode);
}
function handleChatbotClick() {
  emit("chatbotClick");
}
</script>

<style scoped>
.drawer-loading{align-items:center;color:#6b7280;display:flex;font-size:.875rem;justify-content:center;padding:2rem}
</style>
